<template>
    <a class="cw-button-hollow cw-button-hollow-secondary uk-width-medium" @click.prevent="modalStatusStore.showLeadModal()">
        <BaseIcon stroke-width="1.0" width="30" height="30" v-if="showIcon">
            <IconTag></IconTag>
        </BaseIcon>
        {{ buttonText }}
    </a>
</template>

<script setup>
import {useModalStatusStore} from "../../stores/ModalStatusStore";
import BaseIcon from "../ui/BaseIcon.vue";
import IconTag from "../icons/IconTag.vue";

const modalStatusStore = useModalStatusStore()

const props = defineProps({
    showIcon: Boolean,
    buttonText: String
})
</script>
